<template>
  <div class="yx-qjxs-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 请假学生管理 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <el-button type="primary" @click="goto('')">新增</el-button>
          <el-button type="primary" plain>导出</el-button>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <div class="div-scrol">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          @edit="goto"
          @delete="pageDel"
          v-loading="pageLoading"
        >
          <template slot="custom" slot-scope="scope">
            <el-button
              type="primary"
              class="leave-btn"
              @click="goto(scope.row.id)"
              >编辑</el-button
            >
            <!-- <el-button type="success" class="leave-btn" @click="goto(scope.row.id)">修改状态</el-button> -->
            <el-button type="danger" class="leave-btn">删除</el-button>
          </template>
        </c-table>
      </div>
    </el-card>
    <el-dialog
    :append-to-body='true'
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      width="50%"
    >
      <c-form
        v-model="handleData"
        ref="cForm"
        :formRules="formRules"
        :formItems="formItems"
        @submit="submit"
        @resetFields="resetFields"
      >
      </c-form>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/qjxs";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import CForm from "@/components/CForm/index.vue";
let mPage = MPage({
  pagePath: "",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "",
  handleInsertPath: "",
  handleUpdatePath: "",
  handleDownLoadPath: "",
  handleData: {
    id: "",
    11: "",
    12: "",
    13: "",
    14: "",
    15: "",
  },
});
export default {
  mixins: [mPage, mHandle],
  name: "",
  components: { CSearch, CTable, TableBtns, CForm },
  data() {
    let {
      searchItems,
      tableColumns,
      formItems1,
      formItems2,
      formRules,
    } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      formItems1,
      formItems2,
      formItems: [],
      formRules,
      title: "",
      dialogFormVisible: false,
      idList: [],
      pageData: [
        {
          id: 1,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    goto(id) {
      this.dialogFormVisible = true;
      if (id) {
        this.title = "编辑";
        this.formItems = Object.assign({}, this.formItems2);
      } else {
        this.title = "新增";
        this.formItems = Object.assign({}, this.formItems1);
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    pageGetAfterFn(data) {
      data.records.forEach((item) => {
        item.sex = item.sex == 0 ? "男" : "女";
      });
      return data;
    },
    handleDialogClose() {
      this.dialogFormVisible = false;
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
  },
};
</script>
